<template>
  <div>
    <div v-if="$slots.label" class="mb-2 text-sm font-medium">
      <slot name="label" />
    </div>
    <div class="flex flex-wrap items-center">
      <button
        v-for="option in options"
        :key="option.value"
        :test_id="option.label"
        :class="
          twMerge(
            'm-1 flex h-full cursor-pointer items-center justify-between space-x-2 rounded-xl border-2 p-4 shadow-sm focus:outline-none focus-visible:ring focus-visible:ring-neutral-200 focus-visible:ring-offset-2',
            themeColors[themeColor].hover,
            isSelected(option)
              ? themeColors[themeColor].selected
              : themeColors[themeColor].unselected,
            buttonClasses,
          )
        "
        @click="setSelectedOption(option)"
      >
        <span>
          <slot :option="option" />
        </span>
        <CheckFullIcon
          class="order-1 ml-2 h-4 w-4 shrink-0"
          :class="[
            themeColors[themeColor].checkIcon,
            { invisible: !isSelected(option) },
          ]"
        />
      </button>
    </div>
    <FormErrors v-if="hasErrors" :errors="errors" class="mt-2" />
  </div>
</template>

<script setup>
import FormErrors from './FormErrors.vue'
import CheckFullIcon from '~icons/lucide/circle-check'
import { computed } from 'vue'
import { twMerge } from 'tailwind-merge'

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: [Array, String],
    default: '',
  },
  buttonClasses: {
    type: [String, Array],
    default: '',
  },
  themeColor: {
    type: String,
    default: 'secondary',
  },
})

const emit = defineEmits(['update:modelValue'])

const hasErrors = computed(() => {
  const isString = typeof props.errors === 'string'
  return isString ? props.errors : props.errors.length
})

const isSelected = (option) => props.modelValue.includes(option.value)

const setSelectedOption = (option) => {
  if (isSelected(option)) {
    emit(
      'update:modelValue',
      props.modelValue.filter((v) => v !== option.value),
    )
  } else {
    emit('update:modelValue', [...props.modelValue, option.value])
  }
}

const themeColors = {
  primary: {
    selected: 'border-primary-500',
    unselected: 'border-neutral-50',
    hover: 'hover:border-primary-500',
    checkIcon: 'text-primary-500',
  },
  secondary: {
    selected: 'border-secondary-500',
    unselected: 'border-secondary-50',
    hover: 'hover:border-secondary-500',
    checkIcon: 'text-secondary-500',
  },
}
</script>
